import React, { Component, Fragment } from 'react';
import StarredMessages from '../Starred/StarredMessages';
import About from './About';
import Blocked from './BlockedContacts';
import Notification from './Notifications';
import './Setting.scss';
import { SettingOptions, SettingsHeader } from './Settings';
import Chat from './Chat';
import Archive from './ArchivedChat/index';
import { getTranslateTargetLanguage, setLocalWebsettings } from '../../../Helpers/Utility';
import SDK from '../../SDK';
import { REACT_APP_GOOGLE_TRANSLATE_API_KEY } from '../../processENV';
import Store from '../../../Store';
import { transLateLanguageAction } from '../../../Actions/TranslateAction';
import DeleteMyAccount from './DeleteMyAccount';
import PropTypes from 'prop-types';
import Chats from './Chats';
import PrivacySettings from './PrivacySettings';
import { ChevronDown, GodRays, HikeLogoSmall } from '../../../assets/images';

let optionsArray = [
    { label: 'Archived Settings', image: 'Archived' },
    { label: 'Notifications', image: 'notification' },
    { label: 'Starred Messages', image: 'star' },
    { label: 'Blocked Contacts', image: 'blocked' },
    { label: 'Terms & Policies', image: 'about' },
    { label: 'Delete My Account', image: 'delete' },
];
export default class Setting extends Component {
    constructor(props) {
        super(props);
        this.state = {
            parrentView: true,
            activeTab: null,
            setLaunguage: 'English',
        };
    }

    handleSettings = (label = '') => {
        this.setState({
            parrentView: false,
            activeTab: label,
        });
    };
    getLanguages = async () => {
        try {
            const result = await SDK.getTranslateLanguages(REACT_APP_GOOGLE_TRANSLATE_API_KEY);
            const { data: { languages = [] } = {}, statusCode = 0 } = result || {};
            if (statusCode === 200) {
                Store.dispatch(transLateLanguageAction(languages));
            }
        } catch (error) {}
    };

    handleBackToSetting = e => {
        this.setState({
            parrentView: true,
        });
    };

    setSelectedLaun = () => {
        const globalData = Store.getState();
        const {
            TranslateLanguage: {
                translateLanguages: { translateLanguages = [] },
            },
        } = globalData || {};
        const langIndex = translateLanguages?.findIndex(i => i.language === getTranslateTargetLanguage());
        const langSelected = translateLanguages[langIndex]?.name;
        return langSelected;
    };

    componentDidUpdate = () => {
        this.setSelectedLaun();
        getTranslateTargetLanguage() === '' && setLocalWebsettings('translateLang', 'en');
    };

    componentDidMount = () => {
        this.getLanguages();
    };

    render() {
        const { handleBackFromSetting, featureStateData = {}, handleShowCallScreen } = this.props;
        const { isStarMessageEnabled = false, isBlockEnabled = false } = featureStateData;
        if (!isStarMessageEnabled && !isBlockEnabled) {
            const filteredArray = optionsArray.filter(
                option => option.label !== 'Starred Messages' && option.label !== 'Blocked Contacts',
            );
            optionsArray = filteredArray;
        } else if (!isStarMessageEnabled) {
            const filteredArray = optionsArray.filter(option => option.label !== 'Starred Messages');
            optionsArray = filteredArray;
        } else if (!isBlockEnabled) {
            const filteredArray = optionsArray.filter(option => option.label !== 'Blocked Contacts');
            optionsArray = filteredArray;
        }
        const { parrentView, activeTab } = this.state;
        return (
            <Fragment>
                {parrentView && (
                    <div className="setting-container">
                        <div>
                            <div className="settinglist">
                                <SettingsHeader
                                    handleBackFromSetting={handleBackFromSetting}
                                    label={'Settings'}
                                    parrentView={parrentView}
                                />
                                {/* <div
                                    style={{
                                        paddingInline: '1rem',
                                        paddingBlockEnd: '1rem',
                                    }}
                                >
                                    <button
                                        className="privacy_button"
                                        onClick={() => {
                                            this.handleSettings('Privacy');
                                        }}
                                    >
                                        <div
                                            style={{
                                                position: 'relative',
                                                insetBlockStart: '0.25rem',
                                            }}
                                        >
                                            <GodRays className="god_rays" />
                                            <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width="48"
                                                height="48"
                                                viewBox="0 0 48 48"
                                                fill="none"
                                            >
                                                <path
                                                    d="M1.90488 42.0529C0.417595 42.0529 0 41.2303 0 39.838C0 38.4456 0.417595 37.623 1.90488 37.623H3.73383V38.5093H2.468C1.45525 38.5093 1.1642 38.7623 1.1642 39.8384C1.1642 40.9144 1.45525 41.1675 2.468 41.1675H3.7971V42.0537H1.90488V42.0529Z"
                                                    fill="white"
                                                />
                                                <path
                                                    d="M11.2773 39.8388C11.2773 41.6867 10.6636 42.1043 8.9232 42.1043C7.18283 42.1043 6.56909 41.6867 6.56909 39.8388C6.56909 37.9908 7.18283 37.5732 8.9232 37.5732C10.6636 37.5732 11.2773 37.9972 11.2773 39.8388ZM8.9232 41.2185C9.84737 41.2185 10.1131 40.8831 10.1131 39.8388C10.1131 38.7944 9.84737 38.459 8.9232 38.459C7.99904 38.459 7.73329 38.7944 7.73329 39.8388C7.73329 40.8831 7.99904 41.2185 8.9232 41.2185Z"
                                                    fill="white"
                                                />
                                                <path
                                                    d="M18.9789 41.3953C18.9789 41.699 18.8144 42.1039 18.169 42.1039C17.8653 42.1039 17.5616 42.0533 17.3275 41.699L15.5998 39.0981C15.5492 39.0222 15.5112 38.9905 15.4796 38.9905C15.4543 38.9905 15.4037 39.0032 15.4037 39.1171V42.0537H14.4415V38.2692C14.4415 37.7884 14.8085 37.5732 15.2767 37.5732C15.5931 37.5732 15.8968 37.6618 16.0929 37.9529L17.8333 40.5791C17.8649 40.6233 17.8902 40.6866 17.9472 40.6866C18.0168 40.6866 18.0168 40.6107 18.0168 40.5791V37.6235H18.9789V41.3953Z"
                                                    fill="white"
                                                />
                                                <path
                                                    d="M26.8072 41.3953C26.8072 41.699 26.6427 42.1039 25.9973 42.1039C25.6936 42.1039 25.3899 42.0533 25.1558 41.699L23.428 39.0981C23.3774 39.0222 23.3395 38.9905 23.3078 38.9905C23.2825 38.9905 23.2319 39.0032 23.2319 39.1171V42.0537H22.2698V38.2692C22.2698 37.7884 22.6368 37.5732 23.105 37.5732C23.4213 37.5732 23.725 37.6618 23.9216 37.9529L25.6619 40.5791C25.6936 40.6233 25.7189 40.6866 25.7758 40.6866C25.8454 40.6866 25.8454 40.6107 25.8454 40.5791V37.6235H26.8072V41.3953Z"
                                                    fill="white"
                                                />
                                                <path
                                                    d="M33.8126 38.4834H31.5344C31.313 38.4834 31.2371 38.5593 31.2371 38.7807V39.3945H33.7557V40.217H31.2371V40.894C31.2371 41.1155 31.313 41.1914 31.5344 41.1914H33.8379V42.0519H30.7685C30.3572 42.0519 30.0978 41.8494 30.0978 41.3749V38.3054C30.0978 37.8309 30.3572 37.6221 30.7685 37.6221H33.8126V38.483V38.4834Z"
                                                    fill="white"
                                                />
                                                <path
                                                    d="M38.78 42.0529C37.2927 42.0529 36.8751 41.2303 36.8751 39.838C36.8751 38.4456 37.2927 37.623 38.78 37.623H40.609V38.5093H39.3431C38.3304 38.5093 38.0393 38.7623 38.0393 39.8384C38.0393 40.9144 38.3304 41.1675 39.3431 41.1675H40.6722V42.0537H38.78V42.0529Z"
                                                    fill="white"
                                                />
                                                <path
                                                    d="M45.1843 42.0533V38.5092H43.5388V37.623H47.9686V38.5092H46.3232V42.0533H45.1839H45.1843Z"
                                                    fill="white"
                                                />
                                                <path
                                                    d="M0.09729 6V33.8649H18.5929V27.9684H6.35725V22.7999H18.5929V16.9041H6.35725V11.8965H18.5929V6H0.09729Z"
                                                    fill="white"
                                                />
                                                <path
                                                    d="M29.3115 24.0668V33.8661H22.1436V16.9072L29.3115 24.0668Z"
                                                    fill="white"
                                                />
                                                <path
                                                    d="M40.832 6V19.8016L27.0771 6.04666H22.009V11.1155L40.832 29.9393V33.8649H47.9999V6H40.832Z"
                                                    fill="white"
                                                />
                                            </svg>
                                        </div>
                                        Privacy Controls
                                        <ChevronDown className="chevron-down" />
                                    </button>
                                </div> */}
                                <ul className="setting-list-ul">
                                    {optionsArray.map(options => {
                                        const { label, image } = options;
                                        return (
                                            <SettingOptions
                                                key={image}
                                                handleOptions={this.handleSettings}
                                                label={label}
                                                image={image}
                                            />
                                        );
                                    })}
                                    <SettingOptions
                                        handleOptions={this.props.logoutStatus}
                                        enableRightArrow={true}
                                        label={'Logout'}
                                        image={'logout'}
                                    />
                                </ul>
                            </div>
                        </div>
                    </div>
                )}
                {!parrentView && (
                    <Fragment>
                        {activeTab === 'Archived' && <Archive handleBackToSetting={this.handleBackToSetting} />}
                        {activeTab === 'Privacy' && <PrivacySettings handleBackToSetting={this.handleBackToSetting} />}

                        {/* {activeTab === 'chat' &&
                            <Chat
                                setSelectedLaun={(this.setSelectedLaun() !== "") ? this.setSelectedLaun() : "English"}
                                handleBackToSetting={this.handleBackToSetting}
                                featureStateData={featureStateData}
                                 />} */}
                        {activeTab === 'chat' && <Chats handleBackToSetting={this.handleBackToSetting} />}
                        {activeTab === 'notification' && (
                            <Notification handleBackToSetting={this.handleBackToSetting} />
                        )}
                        {activeTab === 'star' && (
                            <StarredMessages
                                handleBackToSetting={this.handleBackToSetting}
                                featureStateData={featureStateData}
                                handleShowCallScreen={handleShowCallScreen}
                            />
                        )}
                        {activeTab === 'blocked' && <Blocked handleBackToSetting={this.handleBackToSetting} />}
                        {activeTab === 'about' && <About handleBackToSetting={this.handleBackToSetting} />}
                        {activeTab === 'delete' && <DeleteMyAccount handleBackToSetting={this.handleBackToSetting} />}
                    </Fragment>
                )}
            </Fragment>
        );
    }
}

Setting.propTypes = {
    handleBackFromSetting: PropTypes.func,
    logoutStatus: PropTypes.func,
    featureStateData: PropTypes.object,
    handleShowCallScreen: PropTypes.func,
};
